import type { TransformedBanner } from 'app/api/services-strapi/banners/types';

function getMatchIdsFromBanners(bannersData: TransformedBanner[] | null): number[] {
  if (!bannersData) {
    return [];
  }

  const ids = bannersData.reduce((acc, { matchOfTheDayId }) => {
    if (typeof matchOfTheDayId === 'number' && !acc.has(matchOfTheDayId)) {
      acc.add(matchOfTheDayId);
    }

    return acc;
  }, new Set<number>());

  return [...ids];
}

export default getMatchIdsFromBanners;
